import { render, staticRenderFns } from "./OwnersRates.vue?vue&type=template&id=52287934&"
import script from "./OwnersRates.vue?vue&type=script&lang=js&"
export * from "./OwnersRates.vue?vue&type=script&lang=js&"
import style0 from "./OwnersRates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports